import { HttpClient } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';
import { ModelViewerUrbaseeService } from '../services/model-viewer-urbasee.service';

@Pipe({
  name: 'auth',
})
export class AuthorizationPipe implements PipeTransform {
  constructor(
    private http: HttpClient,
    private modelViewerUrbaseeService: ModelViewerUrbaseeService
  ) {}

  transform(url: string): Observable<any> {
    return this.http
      .get(url, {
        headers: {
          Authorization: `Bearer ${this.modelViewerUrbaseeService.getJwt()}`,
        },
      })
      .pipe(
        catchError((er) => {
          return of();
        })
      ) as Observable<any>;
  }
}
